
import { Component, Vue, Prop } from "vue-property-decorator";
import RoundIconButton from "../mobile-raise-templates/RoundIconButton.vue";
import { AssetMarkerIconCategory, titleFromClass } from "@/assets/assetMarkerIcons";

// Icon picker for an Asset Type's custom marker icon, modelled on the Mobile Raise Types
// IconsSelector but grouped by category. generic-update-modal binds it via dataType:"component",
// which is why it takes the current class as `value` and emits "input"/"change" ("" resets).
@Component({
	components: {
		"round-button": RoundIconButton,
	},
})
export default class AssetIconPicker extends Vue {
	@Prop({ default: "" }) value: string;
	@Prop({ default: () => [] }) iconCategories: AssetMarkerIconCategory[];
	@Prop({ default: false }) readonly: boolean;

	private isVisible: boolean = false;
	private searchTerm: string = "";

	private get filteredCategories(): AssetMarkerIconCategory[] {
		const term = this.searchTerm.trim().toLowerCase();
		return this.iconCategories
			.map(category => ({
				title: category.title,
				icons: term
					? category.icons.filter(
							i => i.title.toLowerCase().includes(term) || i.cssClass.toLowerCase().includes(term)
					  )
					: category.icons,
			}))
			.filter(category => category.icons.length > 0);
	}

	private get hasIcons(): boolean {
		return this.iconCategories.some(c => c.icons.length > 0);
	}

	private get selectedTitle(): string {
		return this.value ? titleFromClass(this.value) : "";
	}

	private open(): void {
		if (!this.readonly) {
			this.isVisible = true;
		}
	}

	private onIconClick(cssClass: string): void {
		this.$emit("input", cssClass);
		this.$emit("change", cssClass);
		this.isVisible = false;
	}

	private onReset(): void {
		this.$emit("input", "");
		this.$emit("change", "");
	}
}
